import tinymce from 'tinymce/tinymce';

$(document).on("click", "#email-preview-btn", function (evt) {
  evt.preventDefault();
  var form = $(this).closest("form")
  $("#email-entry").val(tinymce.get("email-entry").getContent());
  var toSubmit = form.serialize();
  $.ajax({
    type: "POST",
    url: "/conversations/preview",
    data: toSubmit,
    dataType: "html",
    success: function (data) {
      $("#preview").html(data);
    },
    error: function (resp, status, err) {
      $("#preview").text("Error fetching email preview.");
    }
  });
});

const initRichTextForEmail = function() {
  tinymce.init({
    selector: '#email-entry',
    height: 400,
    menubar: 'edit format',
    skin: false,
    content_css: false,
    plugins: ['link', 'lists'],
    toolbar: [
      { name: 'history',      items: ['undo', 'redo'] },
      { name: 'styles',       items: ['styleselect'] },
      { name: 'formatting',   items: ['bold', 'italic'] },
      { name: 'colors',       items: ['forecolor', 'backcolor'] },
      { name: 'alignment',    items: ['alignleft', 'aligncenter', 'alignright', 'alignjustify'] },
      { name: 'indentation',  items: ['bullist', 'numlist', 'outdent', 'indent'] },
      { name: 'misc',         items: ['link', 'hr'] }
    ]
  });
}

export { initRichTextForEmail };
